// extracted by mini-css-extract-plugin
export var imageContainer = "ProfileImage-module--imageContainer--97cd5";
export var spark = "ProfileImage-module--spark--2b2f7";